import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { Button } from 'client/components/Button/Button'
import LearnWorlds from 'images/learn_worlds.svg'
import Podia from 'images/podia.svg'
import Skillshare from 'images/skillshare.svg'
import Teachable from 'images/teachable.svg'
import Udemy from 'images/udemy.svg'

type TProps = {}

const ALTERNATIVES = [Udemy, Skillshare, Podia, LearnWorlds, Teachable]

const MainBlock: FC<TProps> = () => {
  return (
    <div className="flex w-full flex-col items-center gap-16 pt-30 text-center">
      <div className="flex flex-col items-center gap-2">
        <Text tagName="h2" className="font-title---100px text-palette-white">
          ВЫВЕДИТЕ СВОИ
          <br />
          ЦИФРОВЫЕ ПРОДУКТЫ
          <br />
          НА ГЛОБАЛЬНЫЙ РЫНОК
        </Text>
        <Text tagName="p" className="font-body---24px text-palette-grey--50">
          Продавайте всё: от цифрового арта и курсов
          <br />
          до шаблонов презентаций и to-do листов.
        </Text>
      </div>
      <div className="flex flex-col items-center gap-4">
        <Text tagName="span" className="font-body---24px text-palette-grey--50">
          Мы альтернатива:
        </Text>
        <div className="flex items-center gap-3">
          {ALTERNATIVES.map((item, index) => (
            <img src={item} key={index} className="h-32" />
          ))}
        </div>
      </div>
      <div className="flex w-full justify-center">
        <Button className="font-body---28px h-20 px-14">СВЯЗАТЬСЯ С НАМИ</Button>
      </div>
      <div className="flex w-full flex-col items-center gap-4">
        <div className="flex items-center gap-8">
          <Text tagName="span" className="font-title---120px text-palette-white">
            $ 8,804,586
          </Text>
          <div className="relative">
            <div
              className="h-10 w-10 rounded-half"
              style={{
                background: 'rgba(92, 49, 244, 0.5)',
                backdropFilter: 'blur(2px)',
              }}
            />
            <div className="absolute left-2 top-2 h-6 w-6 rounded-half bg-palette-purple" />
          </div>
        </div>
        {/* <Text tagName="span" className="font-body---24px text-palette-grey--50">
          Made by creators on D-Console
        </Text> */}
      </div>
      <div className="flex flex-col items-center gap-2">
        <Text tagName="h2" className="font-title---100px uppercase text-palette-white">
          ЕСТЬ ИДЕЯ? ТЕПЕРЬ ТЫ МОЖЕШЬ
          <br />
          ВОПЛОТИТЬ ЕЁ В ЖИЗНЬ.
        </Text>
        <Text tagName="p" className="font-body---24px text-palette-grey--50">
          &gt;Более 100 креаторов · 5% фиксированная комиссия · Без платы за подключение и ежемесячных платежей
        </Text>
      </div>
    </div>
  )
}

export { MainBlock }
